export const props = {
  active: {
    type: Boolean,
    default: false
  }
}
